import { Children, ComponentProps, FC } from 'react';
import { propEq } from 'ramda';

import { Body, Footer, Header, Wrapper } from './styles';
import { CardParts, CardProps } from './types';

type CardType = FC<CardProps & ComponentProps<typeof Wrapper>> & CardParts;

// There are 2 ways of using the Card component:
// #1: <Card><Component /></Card>
// #2: <Card>
//       <Card.Header>header</Card.Header>
//       <Card.Body>body</Card.Body>
//       <Card.Footer>footer</Card.Footer>
//     </Card>

/**
 * @deprecated use _core/Card instead
 */
const LegacyCard: CardType = ({ children, shadow, ...props }) => {
  // If one of children is a <Card.Body /> instance,
  // no need to wrap the children in <Card.Body />
  const hasBody = Children.toArray(children).some(
    (child) => child && propEq(Body, 'type', child as Record<'type', unknown>),
  );

  return (
    <Wrapper boxShadow={shadow} {...props}>
      {hasBody ? children : <Body>{children}</Body>}
    </Wrapper>
  );
};

LegacyCard.Body = Body;
LegacyCard.Header = Header;
LegacyCard.Footer = Footer;

export default LegacyCard;
